// extracted by mini-css-extract-plugin
export default {"wrapper":"cc_dv","link":"cc_fB","imageContainer":"cc_gd","image":"cc_dy","textContainer":"cc_dz","title":"cc_c0","description":"cc_cM","mark":"cc_jD"};